// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"ph","categoryName":"qh","categoryImage":"rh","categoryContent":"sh","bottomAligned":"th"};